module.exports = "/_next/static/media/colorwheel.471f82cc.png";